(function($, Global) {
    var FormRegisterComponent = function(model) {
        this.model = model;
    }

	FormRegisterComponent.prototype.initEvents = function() {
        this.publishers();
    }

	FormRegisterComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('submit', '.form-register', function(e) {
            e.preventDefault();

            var $this = $(this);
            var data = $this.serializeJson();
            var $form = $this.closest('form');
            var targetId = e.target.id;

            data['Identifiant'] = data['Identifiant'] && data['Identifiant'].replace(/\s/g, '');

            if (!$('.landing-box').hasClass('loading')) {
                $.Topic('loader-show').publish('.landing-box');
            }

            if ($('.page-signup').exists()) {
                $.Topic('loader-show').publish('.page');
            }

            if ($form.closest('.modal-content').exists()) {
                $.Topic('loader-show').publish($form.closest('.modal-content'));
            }
            var prefix = '';

            var localPathName = Global.location.pathname.toLowerCase();
            if (localPathName == '/fr' || localPathName.startsWith('/fr/')) prefix = "/fr";
            if (localPathName == '/en' || localPathName.startsWith('/en/')) prefix = "/en";

            self.model.register(data, $form, function (data) {
                if (!targetId) {
                    Global.location.replace(prefix+'/SignUp/EmailValidationRequired?confirm');
                } else {
                    Global.location.reload()
                }
            });
        });
    }

	Global.FormRegisterComponent = FormRegisterComponent;
}(jQuery, window));